import { PATIENT_SERVICES_BASE_URL } from '@src/constants';
import { GetFacilityCodeDocument } from '@src/lib/__generated/enterprise-api-sdk';
import { useFacilityIdStore } from '@src/store/modules/facility-id.store';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { useClient } from 'urql';

export function useFacilityId() {
	const client = useClient();
	const { push } = useRouter();
	const { facilityId, setFacilityId } = useFacilityIdStore();
	const [loading, setLoading] = useState(false);

	const getFacilityCode = useCallback(async () => {
		const result = await client.query(GetFacilityCodeDocument, {}).toPromise();
		const facilityCode = result.data?.me?.scheduledVisits?.items?.[0]?.facility?.code || '';
		return { data: facilityCode as string, error: result.error };
	}, [client]);

	useEffect(() => {
		(async () => {
			const needsFacilityId = !facilityId;

			if (needsFacilityId) {
				setLoading(true);

				try {
					const promises: Promise<void>[] = [];

					promises.push(
						getFacilityCode().then(({ data }) => {
							setFacilityId(data);
						})
					);

					await Promise.all(promises);
				} catch {
					push(`/${PATIENT_SERVICES_BASE_URL}/global-error/`);
				} finally {
					setLoading(false);
				}
			}
		})();
	}, [facilityId, getFacilityCode, setFacilityId]);

	return { facilityId, loading, setFacilityId };
}
